// extracted by mini-css-extract-plugin
export default {"cls1":"vMN9JEx1JqmnlitQfS9h","cls2":"MoshYnISJvmKa4HGOK54 vMN9JEx1JqmnlitQfS9h"};